import { Modal } from "antd";
import DeleteIcon from "../../assets/icons/DeleteIconnew.svg"
import "./DeleteConfirmModel.css"

interface DeleteConfirmModelProps {
    visible: any;
    onCancel: () => void;
    title?: string;
    content?: string;
    onConfirm: () => void;
    cancelText?: string;
    okText?: string;
    count:number
}
const DeleteConfirmModel = ({ visible, onCancel, title, content, onConfirm, cancelText, okText,count }: DeleteConfirmModelProps) => {


    return (
        <div>
            <Modal
                className="deleteModal"
                centered
                open={visible?.state ?? visible}
                okText={okText}
                cancelText={cancelText}
                onOk={onConfirm}
                onCancel={onCancel}
                mask={true}
                maskClosable={false}
                width={300}

            >
                <div className="mt-1">
                    <div className="delete-wrapper w-100 text-center ">
                        <img src={DeleteIcon} alt="deleteIcon"  />
                        <p className="file-text mt-1 mb-0">{count > 0 ? `${count}  Module Selected` : ""}</p>
                    </div>
                    <div className="content-wrapper text-center mt-2">
                        {/* <p className="text-black mb-0 fw-bold title-text ">{title}</p> */}
                        <p className="mb-0 mt-1 content-text">{content}</p>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
export default DeleteConfirmModel